<template>
  <h3>Рисковые Поправки (РП)</h3>
  <div class="block">
    <h5>РП ОВТ</h5>
    <p>При загрузке РУ, автоматически формируется расчет по рисковым поправкам по ОВТ используя метод «Bootstrap». В данном методе нужно заполнить фильтры: «Уровень доверия, %» и «Количество симуляций».</p>
    <img src="@/assets/img/guide/bootstrap-header.png" alt="" srcset="">
  </div>
  <div class="block">
    <h5>РП ООЧП</h5>
    <p>Для расчета по ООЧП необходимо загрузить РП по ООЧП и ДП ООЧП отдельными файлами.</p>
    <p>В данном разделе доступны четыре метода расчета:</p>
    <ul>
      <li>метод Мака «по произошедшим убыткам» (по умолчанию)</li>
      <li>метод Мака «андеррайтинговый»</li>
      <li>метод «На основании волатильности по произошедшим убыткам»</li>
      <li>метод «На основании волатильности андеррайтинговый»</li>
    </ul>
    <img src="@/assets/img/guide/rp-add-method.png" alt="" srcset="">
    <p>В методах «Мака по произошедшим убыткам» и «На основании волатильности по произошедшим убыткам» 
      данные берутся из расчета резерва убытков (заработанная премия и коэффициенты убыточности).
    </p>
    <p>В двух других методах (метод Мака «андеррайтинговый» и метод «На основании волатильности андеррайтинговый») премия предыдущих периодов берется из загрузки «РП ООЧП». 
      В данном случае, на интерфейсе нужно ввести прогноз премии на следующий год. 
      Коэффициенты убыточности берутся из загрузки «РП ООЧП».</p>
    <img src="@/assets/img/guide/rp-forecast.png" alt="" srcset="">
    <p>В методах «На основании волатильности по произошедшим убыткам» и «На основании волатильности андеррайтинговый» перед проведением расчета можно указать квантиль и метод расчета:</p>
    <ul>
      <li>Мультипликативный</li>
      <li>Аддитивный</li>
    </ul>
    <img src="@/assets/img/guide/rp-volatility.png" alt="" srcset="">
    <p>Также предусмотрен выбор убыточности за разные периоды:</p>
    <ul>
      <li>Предыдущий период</li>
      <li>Средняя за предыдущие 2 периода</li>
      <li>Средняя за предыдущие 4 периода</li>
      <li>Средняя за предыдущие 8 периодов</li>
      <li>Прогноз из загрузки</li>
      <li>Ручной ввод</li>
    </ul>
    <img src="@/assets/img/guide/rp-deviation.png" alt="" srcset="">
    <p>В методе Мака «по произошедшим убыткам» и методе Мака «андеррайтинговый» необходимо указать «Квантиль, %».</p>
    <img src="@/assets/img/guide/mac-calculation-header.png" alt="" srcset="">
  </div>
</template>
  
<script>
export default {
  name: 'BestEstimates',
}
</script>

<style scoped>
h3{
  font-size: 32px;
  color: #0074b5;
}

h5{
  margin: 20px 0px;
  font-size: 24px;
  color: #0074b5;
}

.list{
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.list p{
  font-size: 16px;
}

table, th, td {
  color: #6b6f77;
  border: 1px solid black;
  border-collapse: collapse;

  margin: 20px 0px;
}

th{
  padding: 0px 10px;
}

td:nth-child(1){
  padding: 10px;
}

td:nth-child(2){
  padding: 10px 10px 10px 30px;
}

ul{
  display: flex;
  flex-direction: column;
  gap: 10px;

  margin: 20px 20px 20px 50px;
}

td ul{
  margin-left: unset;
}

ol{
  margin-left: 50px;
}

ol li{
  margin-top: 10px;
}

li p{
  margin-top: 10px;
}

ol li ul{
  margin-left: 50px;
}

p{
  margin-top: 10px;
  line-height: 20px;
}

img{
  max-width: 100%;
  margin: 50px 0px;
}
</style>
